<template>
    <div>
        <p class="mb-sm">Please fill in the solar PV system configuration details below.</p>
        <ConfigurationSummary :configuration="systems" />

        <template v-for="(system, index) in $v.systems.$each.$iter">
            <System v-if="system.$model.inverter.details.inverterType == 'micro'" :key="index" v-slot="{ startMppt, mpptsPerDiagram }" :index="index" :system="system">
                <SystemDiagramMicro
                    :system="system"
                    :panel-options="panelSimpleArray"
                    :start-mppt="startMppt"
                    :mppts-per-diagram="mpptsPerDiagram"
                />
            </System>

            <System v-else :key="index" v-slot="{ startMppt, mpptsPerDiagram, flags }" :index="index" :system="system" :temperature="temperature" :building-type="buildingType">
                <SystemDiagramString
                    :system="system"
                    :temperature="temperature"
                    :building-type="buildingType"
                    :panel-options="panelSimpleArray"
                    :start-mppt="startMppt"
                    :mppts-per-diagram="mpptsPerDiagram"
                    :flags="flags"
                />
            </System>
        </template>

        <FieldCheckboxes v-model="agreeToTerms" class="field--full" :options="[{ label: 'While all care has been taken to ensure the My Jobs solution is free from omission and error, the Clean Energy Council takes no responsibility for the use of this information in the design and/or installation of any solar PV system. Please see our <a class=\'link\' href=\'/legal\' target=\'_blank\'>Website User Terms and Conditions</a>.', value: 'Agree' }]" :v="$v.agreeToTerms" />
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { validationMixin } from 'vuelidate';
import { required, requiredIf, between } from 'vuelidate/lib/validators';
import System from "@/jobs/new/System";
import ConfigurationSummary from "@/jobs/new/ConfigurationSummary";
import SystemDiagramString from "@/jobs/new/SystemDiagramString";
import SystemDiagramMicro from "@/jobs/new/SystemDiagramMicro";
import FieldCheckboxes from '@/form/Checkboxes';

// Validation to detect inverterType
const requiredByType = (param) => requiredIf(function (model) {
    const parent = this.$v.systems.$model.find((system) => {
        return system.mppts.find((mppt) => mppt == model);
    });
    return parent.inverter.details.inverterType == param;
});

export default {
    components: {
        System,
        SystemDiagramString,
        SystemDiagramMicro,
        FieldCheckboxes,
        ConfigurationSummary,
    },

    mixins: [validationMixin],

    data() {
        return {
            agreeToTerms: []
        }
    },

    computed: {
        ...mapState('job', ['temperature', 'buildingType']),
        ...mapGetters('configuration', { systems: 'sorted' }),
        ...mapGetters('products', ['panelSimpleArray']),
    },

    validations: {
        agreeToTerms: {
            required
        },
        systems: {
            $each: {
                inverter: {
                    required
                },
                mppts: {
                    $each: {
                        parallel: {
                            required: requiredIf('panel'),
                            between: between(1, 100)
                        },
                        series: {
                            required: requiredIf('panel'),
                            between: between(1, 100)
                        },
                        panel: {
                            required: requiredByType('micro')
                        }
                    }
                }
            }
        }
    },

    // watch: {
    //     systems: {
    //         deep: true,
    //         handler(config) {
    //             this.updateConfiguration(config);
    //         }
    //     }
    // },

    created() {
        // Resave sorted config as original config
        this.updateConfiguration(this.systems);
        this.setSinglePanel();
        this.removeRougePanels();
    },

    methods: mapActions('configuration', ['updateConfiguration', 'setSinglePanel', 'removeRougePanels'])
};
</script>
